import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';

export default class PredictedOccupancySerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalize(
    typeClass: ModelSchema,
    hash: {
      extract_date: string;
      extract_datetime: string;
      extract_datetime_utc?: string;
    },
  ) {
    const rawExtractDate = hash.extract_date;

    if (rawExtractDate) {
      // TODO: Remove this when backend provides the datetime
      // Currently we only get the date in UTC and not the datetime, so we need to add 10 hours and 45 minutes, as we only update the predicted occupancy at 10:45 UTC
      hash.extract_datetime = `${rawExtractDate}T10:45:00.000Z`;
      // Clone extractDate to extractDateTimeUtc so that we can use both the local time and UTC time, also adding the offset
      hash.extract_datetime_utc = `${rawExtractDate}T10:45:00.000Z`;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.normalize(typeClass, hash);
  }
}
